import axios from 'axios';

export default async (token) => {
  try {
    const { data, status } = await axios.get(`${process.env.REACT_APP_API_URL}/auth/users/me/`, {
      headers: {
        'Authorization': `JWT ${token}`
      }
    });
    if (status === 200) {
      return data;
    }
  } catch (error) {
    throw (error);
  }
}